import { isElectron } from '../electron';

/**
 * This browser can share its screen on a call. The desktop app cannot yet:
 * Electron's getDisplayMedia needs a main-process source picker, which does
 * not exist, so the desktop app offers no Share button (it still shows other
 * people's screens).
 */
export function canShareScreen(): boolean {
  return !isElectron
    && typeof navigator !== 'undefined'
    && typeof navigator.mediaDevices?.getDisplayMedia === 'function';
}

/**
 * What to tell the user when sharing did not start, or null when there is
 * nothing to say: they closed the browser's picker. livekit-client passes
 * getDisplayMedia's DOMException through `setScreenShareEnabled` unchanged.
 */
export function screenShareErrorMessage(error: unknown): string | null {
  const { message, name } = (error ?? {}) as { message?: unknown; name?: unknown };
  if (name === 'NotAllowedError' || name === 'PermissionDeniedError') {
    // Chrome on macOS without the Screen Recording permission.
    if (typeof message === 'string' && /system/i.test(message)) {
      return 'Screen sharing is blocked. Allow your browser to record the screen in System Settings, then try again.';
    }
    return null;
  }
  return 'Could not share your screen. Try again.';
}
